/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React from 'react'
import { Cell } from '@tanstack/react-table'
import UiTableCellItem from './UiTableCellItem'

interface UiTableRowCellsListProps {
    cells: Cell<any, unknown>[]
    decorationId: string
}

const UiTableRowCellsList = (props: UiTableRowCellsListProps) => {
    if (!props.cells.length) {
        return null
    }

    return (
        <>
            {props.cells.map((cell) => (
                <UiTableCellItem
                    key={cell.id}
                    cell={cell}
                    decorationId={props.decorationId}
                />
            ))}
        </>
    )
}

export default UiTableRowCellsList
